import React, { useState } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useSpaceInformationByInviteCode } from '@zep/apis';
import { useDialog } from '@zep/dialog';
import { XIcon } from '@zep/icons';
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay, DialogPanel, DialogTitle, IconContainer, Input, TextField } from '@zep/ui';
import { ErrorStatus } from '../../../../consts';

/**
 * 코드로 입장 버튼 클릭 시 나오는 모달
 */
const _EnterCodeModal = () => {
  const {
    visible,
    remove
  } = useModal();
  const dialog = useDialog();
  const router = useRouter();
  const {
    t
  } = useTranslation(['home'], {
    useSuspense: true
  });
  const [enterCode, setEnterCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {
    mutateAsync
  } = useSpaceInformationByInviteCode();
  const handleOnChange = ({
    target
  }: React.ChangeEvent<HTMLInputElement>) => setEnterCode(target.value);
  const handleClick = async () => {
    if (enterCode.length === 0) {
      return dialog.alert({
        title: t('home:space_enter_code_contents')
      });
    }
    try {
      setIsLoading(true);
      const invitedData = await mutateAsync(enterCode);
      router.push(`/play/${invitedData.space.entry_map_hash_id}`);
      logger.track('home_enter_code_complete');
    } catch (error: any) {
      // 잘못된 코드 요청 시
      if (error.status === ErrorStatus.FAILED) {
        dialog.alert({
          title: t('home:space_enter_there_is_no_such_code')
        });
      } else {
        dialog.alert({
          title: t('home:space_enter_something_wrong')
        });
      }
      setEnterCode('');
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  };
  return <Dialog open={visible} onClose={() => {}} drawer data-sentry-element="Dialog" data-sentry-component="_EnterCodeModal" data-sentry-source-file="EnterCodeModal.tsx">
      <DialogOverlay data-sentry-element="DialogOverlay" data-sentry-source-file="EnterCodeModal.tsx" />
      <DialogPanel data-sentry-element="DialogPanel" data-sentry-source-file="EnterCodeModal.tsx">
        <DialogHeader leftSlot={<DialogTitle>{t('home:space_me_enter_with_code')}</DialogTitle>} rightSlot={<IconContainer onClick={remove}>
              <XIcon />
            </IconContainer>} data-sentry-element="DialogHeader" data-sentry-source-file="EnterCodeModal.tsx" />

        <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="EnterCodeModal.tsx">
          <TextField label={t('home:space_enter_code')} data-sentry-element="TextField" data-sentry-source-file="EnterCodeModal.tsx">
            <Input type="text" name="spaceEnterCode" value={enterCode} onChange={handleOnChange} minLength={6} placeholder={t('home:space_enter_code_morethan_6words')} isFullWidth autoFocus data-sentry-element="Input" data-sentry-source-file="EnterCodeModal.tsx" />
          </TextField>
        </DialogContent>

        <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="EnterCodeModal.tsx">
          <Button type="button" variant="primary" disabled={enterCode.length < 6} isLoading={isLoading} onClick={handleClick} data-sentry-element="Button" data-sentry-source-file="EnterCodeModal.tsx">
            {t('home:space_enter_with_code_button')}
          </Button>
        </DialogFooter>
      </DialogPanel>
    </Dialog>;
};
export const EnterCodeModal = NiceModal.create(_EnterCodeModal);